<template>
  <div ref="strip" class="s-fleet-leasing">
    <div class="page-container">
      <div class="s-fleet-leasing__header mb-30">
        <div class="title h2">{{ title }}</div>

        <div class="form-chunk-list">
          <div v-for="item in types" :key="item.value" class="form-chunk">
            <input
              :id="item.value"
              v-model="type"
              class="form-check-input"
              type="radio"
              name="types"
              :value="item.value"
              @change="onChangeType" />
            <label class="form-check-label" :for="item.value">
              {{ item.text }}
            </label>
          </div>
        </div>
      </div>

      <Accordion
        v-if="rates"
        :title="rates.title"
        :is-active-prop="false"
        class="theme-icon-cirle mb-40">
        <article class="b-article" v-html="rates.summary"></article>
      </Accordion>

      <div v-if="rates?.contactNoteText" class="mb-40">
        <section class="s-contact-note">
          <div class="s-contact-note__body">
            <div class="s-contact-note__details">
              <div class="s-contact-note__picture">
                <IdeaLottie />
              </div>
              <div>
                <div class="s-contact-note__sub-title">
                  {{ rates.contactNoteSubTitle }}
                </div>
                <div class="s-contact-note__description">
                  {{ rates.contactNoteText }}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div
        v-if="recordsCountFiltered"
        ref="grid"
        v-auto-animate
        class="s-fleet-leasing__grid mb-60">
        <div
          v-for="item in recordsFilteredPaged"
          :key="item.id"
          class="s-fleet-leasing__item">
          <VehicleLeasing
            v-if="item.documentTypeAlias === defaultOfferType"
            :item="item"
            :show-compare="false" />
          <VehicleSaverLeasing
            v-if="item.documentTypeAlias === saverOfferType"
            :item="item"
            :show-compare="false" />
        </div>
      </div>

      <div v-if="!recordsCountFiltered">
        <NoResults></NoResults>
      </div>

      <div class="d-flex justify-content-center">
        <Anchor
          v-if="viewMoreLink"
          :item="viewMoreLink"
          class="btn btn-outline-primary" />
      </div>
    </div>
  </div>
</template>

<script>
import IdeaLottie from '../components/lotties/Idea.vue'
import * as lib from '../../lib/lib'
import VehicleLeasing from '../components/VehicleLeasing.vue'
import VehicleSaverLeasing from '../components/VehicleSaverLeasing.vue'
import NoResults from '../components/common/NoResults.vue'
import Anchor from './../components/common/Anchor.vue'
import Accordion from './../components/BookingAccordion.vue'
/* eslint-disable no-unused-vars */
import { compact, uniqBy } from 'lodash'
import constants from './../../lib/constants'

const { offerType } = constants.leasing

export default {
  components: {
    Anchor,
    NoResults,
    VehicleLeasing,
    VehicleSaverLeasing,
    Accordion,
    IdeaLottie,
  },

  data() {
    return {
      title: null,
      records: [],
      recordsCount: null,
      recordsFiltered: [],
      page: 1,
      itemsPerPage: this.configuration.itemsPerPage,
      types: [],
      type: '',
    }
  },
  computed: {
    defaultOfferType() {
      return offerType.default
    },
    saverOfferType() {
      return offerType.saver
    },
    rates() {
      return this.types.find((i) => i.value === this.type)?.rates
    },

    viewMoreLink() {
      return this.types.find((i) => i.value === this.type)?.link
    },

    recordsFilteredPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage
      return this.recordsFiltered.slice(start, end)
    },

    recordsCountFiltered() {
      return this.recordsFiltered.length
    },
  },
  mounted() {
    const { title, records, types } = lib.getData('fleetData')
    this.title = title
    this.records = records
    this.recordsCount = this.records.length
    this.types = types
    this.setPreselectedOptions()
    this.onChangeType()
  },
  methods: {
    onChangeType() {
      this.recordsFiltered = this.records.filter((i) =>
        i.categories.split('|').some((x) => x.includes(this.type))
      )
    },

    setPreselectedOptions() {
      const entry = this.types.find((i) => i.selected)
      this.type = entry ? entry.value : ''
    },
  },
}
</script>
